/** Prefix ใน CMS imageKey — ชี้ไปรูปบริการใน Stock POS */
export const STOCK_PUBLIC_IMAGE_PREFIX = "stock-public:";

const SERVICE_FILE_PREFIX = "uploads/services/";

export function isStockPublicImageKey(key: string | null | undefined): boolean {
  return !!key?.startsWith(STOCK_PUBLIC_IMAGE_PREFIX);
}

export function stockPublicFileKeyFromImageKey(key: string): string {
  return key.slice(STOCK_PUBLIC_IMAGE_PREFIX.length);
}

/** แปลง Stock public image URL → CMS imageKey */
export function toStockPublicImageKey(
  imageUrl: string | null | undefined,
): string | null {
  if (!imageUrl?.trim()) return null;
  const trimmed = imageUrl.trim();
  const fromApi = trimmed.match(/\/api\/public\/files\/(.+)$/);
  if (fromApi?.[1]) {
    return `${STOCK_PUBLIC_IMAGE_PREFIX}${decodeURIComponent(fromApi[1])}`;
  }
  if (trimmed.startsWith(SERVICE_FILE_PREFIX)) {
    return `${STOCK_PUBLIC_IMAGE_PREFIX}${trimmed}`;
  }
  return null;
}

export function stockImageKeyFromService(dto: {
  imageUrl?: string | null;
  images?: { url: string }[];
}): string | null {
  const url = dto.imageUrl?.trim() || dto.images?.[0]?.url?.trim();
  if (!url) return null;
  return toStockPublicImageKey(url);
}

export function isAllowedStockPublicFileKey(fileKey: string): boolean {
  const normalized = fileKey.replace(/^\/+/, "");
  return normalized.startsWith(SERVICE_FILE_PREFIX);
}

export function resolveStockPublicImageProxyUrl(
  imageKey: string,
  apiBase: string,
): string {
  const fileKey = stockPublicFileKeyFromImageKey(imageKey);
  return `${apiBase.replace(/\/$/, "")}/stock-public/files/${fileKey}`;
}
